<template>
  <article class="document-page">
    <header class="document-header">
      <p class="protocol-label">Deployment file</p>
      <h1>{{ title }}</h1>
    </header>
    <section v-if="content" class="document-section">
      <div class="section-heading">
        <h2>Contents</h2>
      </div>
      <div class="code-panel rich-code">
        <SafeHtml :content="content" />
      </div>
    </section>
    <a v-if="fileName" class="primary-action" href="/files/docker-compose.yml" download>
      Download file
    </a>
  </article>
</template>

<script>
import SafeHtml from './SafeHtml.vue';

export default {
  name: 'File',
  components: { SafeHtml },
  props: {
    title: { type: String, default: '' },
    content: { type: String, default: '' },
    fileName: { type: String, default: '' }
  }
};
</script>
